<!--
Author: TangChen
Date: 2018-10-25
Desc: 我的现金宝七日年化和万份收益绘制曲线图组件，由index.js 配置引入
-->
<template>
    <div v-if="chart.color" :class="'bizcomp-currency-chart bizcomp ' + className">
        <comp-title :title="title" />
        <chart :option="chart" :char-cate="charCate" :ref-v="'currency'" />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import chart from "@/components/misc/chart.vue";
export default {
    name: "CurrencyChart",
    components: {
        chart
    },
    mixins: [mixin],
    data() {
        return {
            chart: {}
        };
    },
    created() {
        this.getXjbInfo();
    },
    methods: {
        // 获取现金宝信息
        getXjbInfo() {
            const _this = this;
            this.$util.request("xjb/query/info&").then((res) => {
                if (res.data) {
                    const xjbInfo = res.data;
                    if (xjbInfo.length > 0) {
                        let _obj = [];
                        let _objUnit = [];
                        let _xV = [];
                        for (let i = xjbInfo.length - 1; i >= 0; i--) {
                            _xV.push(xjbInfo[i].incomedate);
                            _obj.push(Number(xjbInfo[i].growthrate));
                            _objUnit.push(Number(xjbInfo[i].fundincomeunit));
                        }
                        _this.chart = {
                            xData: _xV,
                            color: ["#e99400", "#008cd4"],
                            name: ["七日年化收益率(%)", "万份收益(元)"],
                            data: [_obj, _objUnit]
                        };
                    }
                }
            });
        }
    }
};
</script>
